
import { Vue } from "vue-class-component";

export default class StiSc extends Vue {}
